import { message } from "ant-design-vue"

/**
 * Уведомления
 */
export default {
	install(Vue) {
		Vue.prototype.$alert = message
	}
}
